import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5bde8c3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "qrCodeUrl"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: "qrCodeDiv",
    style: _normalizeStyle($options.qrCodeDivStyles)
  }, [_createElementVNode("img", _hoisted_1, null, 512)], 4);
}